import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import LoginPage from "./pages/LoginPage/LoginPage"
import AuthProvider from "./components/AuthProvider"
import PrivateRoute from "./components/PrivateRoute"
import { SearchProvider } from "./context/KeywordSearchContext"
import TrainingPage from "./pages/Trainings/TrainingPage"
import VideoDetail from "./pages/Trainings/VideoDetail"
import EvaluationPage from "./pages/Evaluations/EvaluationPage"
import TypeFormPage from "./pages/Evaluations/TypeFormPage"
import HomePage from "./pages/HomePage/HomePage"
import VerifyOtpPage from "./pages/LoginPage/VerifyOtpPage"

const App = () => {

    return (
        <Router>
            <AuthProvider>
                <SearchProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage />}/>
                        <Route path="/verify-otp" element={<VerifyOtpPage />} />
                        <Route element={<PrivateRoute />}>
                            <Route path="*" element={<Navigate to="/home" replace/>}/>
                            <Route path="/home" element={<HomePage />} />
                            <Route path="/training" element={<TrainingPage />} />
                            <Route path="/video/:id" element={<VideoDetail />} />
                            <Route path="/evaluation" element={<EvaluationPage />} />
                            <Route path="/typeForm" element={<TypeFormPage />} />
                        </Route>
                    </Routes>
                </SearchProvider>
            </AuthProvider>
        </Router>        
    )
}

export default App